import "./School.css";
import { useState } from "react";
import { useLang } from "../../../utils/i18n";

const School = () => {
  const lang = useLang();
  const [openProgramme, setOpenProgramme] = useState(null);
  const copy = {
    en: {
      heading: "Monetique School",
      introTitle: "Where communication, leadership and global strategy come together.",
      introBody:
        "Monetique School is Monetique's educational arm, created for professionals who want to speak, lead and perform with confidence in an international environment. Our programmes combine strategic communication, executive fluency and global leadership skills to help professionals grow faster and stand out in competitive markets. We believe language is more than words. It is influence, presence and vision. Every class, workshop and coaching session is designed to elevate how leaders think, communicate and act in a global business setting.",
      card1Title: "Executive Communication & Leadership",
      card1Body:
        "We support executives with strategic and clear communication focused on leadership. From reviewing high impact materials and decisions to strengthening your financial narrative and executive storytelling, we help you communicate with confidence and precision.\n\nYou receive direct support on essential leadership challenges, key FP&A themes and AI enabled strategic productivity, all through an exclusive individual access channel designed for your continuous development as a business leader.",
      card2Title: "Career Acceleration",
      card3Title: "Workshops on Demand (Co Branded)",
      card4Title: "Business English Club",
      comingSoon: "Coming soon",
    },
    pt: {
      heading: "Monetique School",
      introTitle: "Onde comunicação, liderança e estratégia global se encontram.",
      introBody:
        "Escola Monetique é o braço educacional da Monetique, criado para profissionais que desejam falar, liderar e atuar com confiança em um ambiente internacional. Nossos programas combinam comunicação estratégica, fluência executiva e habilidades de liderança global para ajudar profissionais a crescerem mais rápido e se destacarem em mercados competitivos. Acreditamos que a linguagem é mais do que palavras, é influência, presença e visão. Cada aula, workshop e sessão de coaching é projetada para elevar a forma como os líderes pensam, comunicam e atuam em um cenário empresarial global.",
      card1Title: "Comunicação Executiva & Liderança",
      card1Body:
        "Apoiamos executivos com comunicação estratégica, clara e orientada à liderança. Desde a revisão de materiais e decisões de alto impacto até o fortalecimento da sua narrativa financeira e storytelling executivo, ajudamos você a comunicar com segurança e precisão.\n\nVocê recebe suporte direto em desafios essenciais de liderança, temas críticos de FP&A e produtividade estratégica impulsionada por IA, tudo por meio de um canal exclusivo de acesso individual, especialmente desenhado para o seu desenvolvimento contínuo como líder empresarial.",
      card2Title: "Aceleração de Carreira",
      card3Title: "Workshops Sob Demanda (Co-branded)",
      card4Title: "Business English Club",
      comingSoon: "Em breve",
    },
  };

  const programmes = [
    {
      title: copy[lang].card1Title,
      body: copy[lang].card1Body,
      status: null,
    },
    {
      title: copy[lang].card2Title,
      body: null,
      status: copy[lang].comingSoon,
    },
    {
      title: copy[lang].card3Title,
      body: null,
      status: copy[lang].comingSoon,
    },
    {
      title: copy[lang].card4Title,
      body: null,
      status: copy[lang].comingSoon,
    },
  ];

  return (
    <section className="monetique-school">
      <h1 className="main-heading">{copy[lang].heading}</h1>
      <div className="school-description">
        <h2 className="school-description-title">{copy[lang].introTitle}</h2>
        <p className="school-description-copy">{copy[lang].introBody}</p>
      </div>
      <section
        className="school-programs"
        aria-label={lang === "en" ? "Monetique School programmes" : "Programas da Monetique School"}
      >
        {programmes.map((programme, index) => {
          const isOpen = openProgramme === index;
          const triggerId = `school-programme-trigger-${index}`;
          const panelId = `school-programme-panel-${index}`;

          return (
          <article
            className={`school-program school-program-disclosure ${programme.status ? "is-soon" : "is-active"} ${isOpen ? "is-open" : ""}`}
            key={programme.title}
          >
            <button
              className="school-program-summary"
              type="button"
              id={triggerId}
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => setOpenProgramme(isOpen ? null : index)}
            >
              <span className="school-program-index">{`0${index + 1}`}</span>
              <span className="school-program-title">{programme.title}</span>
            </button>
            <div
              className="school-program-panel"
              id={panelId}
              role="region"
              aria-labelledby={triggerId}
              aria-hidden={!isOpen}
            >
              <div className="school-program-panel-inner">
                {programme.status ? (
                  <p className="school-program-status">{programme.status}</p>
                ) : (
                  <p className="school-program-text school-program-text-preline">{programme.body}</p>
                )}
              </div>
            </div>
          </article>
          );
        })}
      </section>
    </section>
  );
};

export default School;
